export const mexico = [
  {
    id: 0,
    state: 'Aguascalientes',
    url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-AGU_governors.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 1,
    state: 'Durango',
    url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-DUR_governors.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 2,
    state: 'Hidalgo',
    url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-HID_governors.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 3,
    state: 'Oaxaca',
    url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-OAX_governors.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 4,
    state: 'Quintana Roo',
    url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-ROO_governors.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 5,
    state: 'Tamaulipas',
    url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-TAM_governors.json?timestamp=${new Date().getTime()}`,
  },
];

export const brasil = [
  {
    id: 0,
    state: 'Brasil',
    url: `https://data-ecp.infobae.com/infobae.com/2022/brasil/general/BR_president.json?timestamp=${new Date().getTime()}`,
  },
];

export const brasilVuelta = [
  {
    id: 0,
    state: 'Brasil',
    url: `https://data-ecp.infobae.com/infobae.com/2022/brasil/general_vuelta/BR_president.json?timestamp=${new Date().getTime()}`,
  },
];

export const initial = [
  {
  },
];

export const peru = [
  {
    id: 0,
    state: 'Lima',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/municipal/PE-LIM_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 1,
    state: 'Arequipa',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional/PE-ARE_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 2,
    state: 'La Libertad',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional/PE-LAL_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 3,
    state: 'Cusco',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional/PE-CUS_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 4,
    state: 'Loreto',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional/PE-LOR_president.json?timestamp=${new Date().getTime()}`,
  },
];

export const peruPercent = [
  {
    id: 0,
    state: 'Lima',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/municipal-porcentaje/PE-LIM_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 1,
    state: 'Arequipa',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional-porcentaje/PE-ARE_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 2,
    state: 'La Libertad',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional-porcentaje/PE-LAL_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 3,
    state: 'Cusco',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional-porcentaje/PE-CUS_president.json?timestamp=${new Date().getTime()}`,
  },
  {
    id: 4,
    state: 'Loreto',
    url: `https://data-ecp.infobae.com/infobae.com/2022/perú/regional-porcentaje/PE-LOR_president.json?timestamp=${new Date().getTime()}`,
  },
];